import { render, staticRenderFns } from "./Pitches.vue?vue&type=template&id=b3f58b5e&scoped=true"
import script from "./Pitches.vue?vue&type=script&lang=js"
export * from "./Pitches.vue?vue&type=script&lang=js"
import style0 from "./Pitches.vue?vue&type=style&index=0&id=b3f58b5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3f58b5e",
  null
  
)

export default component.exports